import './index.erb';
import { Application, Controller } from 'utils/stimulus';

import 'utils/current_user';
import './components/hero';
import './components/articles';
import './components/benefits';

import 'images/practice_tests/colored-plus-shapes.svg';

class RankingsShowController extends Controller {
  static targets = ['form', 'email', 'name', 'success'];

  formFocus() {
    if (!this.hasNameTarget) {
      return;
    }

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    setTimeout(() => this.nameTarget.focus(), 500);
  }

  reloadWithTracking() {
    const targetData = this.formTarget.dataset;

    let trackingParams = new URLSearchParams();
    trackingParams.set('utm_source', targetData.trackingSource);
    trackingParams.set('utm_medium', targetData.trackingMedium);
    trackingParams.set('utm_campaign', targetData.trackingCampaign);
    trackingParams.set('utm_term', targetData.trackingTerm);

    location.search = trackingParams.toString();
  }

  send(e) {
    e.preventDefault();

    const userIsSignedIn = window.currentUser;

    window.UserTracker.emit('event', {
      eventName: 'practice test ranking subscribed',
      data: {
        name: this.nameTarget.value,
        email: this.emailTarget.value,
        slug: this.data.get('slug')
      }
    })
      .then(() => {
        this.formTarget.classList.add('hidden');
        this.successTarget.classList.remove('hidden');

        if (userIsSignedIn) {
          setTimeout(() => this.reloadWithTracking(), 2000);
        }
      })
      .catch((err) => {
        const msg =
          'Não foi possível realizar a sua inscrição no momento, tente novamente mais tarde.';
        Rollbar.error(msg, err);
        toastr.error(msg);
      });
  }
}

if (!window.RankingsShowApp) {
  window.RankingsShowApp = Application.start();
  window.RankingsShowApp.register(
    'rankings-subscription',
    RankingsShowController
  );
}
